/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from "@emotion/react";
import React from "react";
import { Button } from "ui/chakra/components/Button";

export type AddToCartButtonProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  onClick,
}) => {
  return (
    <Button variant="solid" size="sm" onClick={onClick}>
      カートに入れる
    </Button>
  );
};
